<script>
	import { Table, DropdownItem } from "@sveltestrap/sveltestrap";
	import Pagination from "../../../components/CustomPaginate/Pagination.svelte";
	import CustomModal from "../../../components/CustomModal/CustomModal.svelte";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import { navigate } from "svelte-routing";
	import {
		convertDateOnly,
		convertTimeOnly,
	} from "../../../services/helpers";
	import { editBlackoutData } from "../../../store/store";
	import TableDropdown from "../../../components/TableDropdown/TableDropdown.svelte";

	export let data;
	export let handleInactive;
</script>

<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<th>Blackout start date</th>
				<th>Blackout end date</th>
				<th class="col-3">Vehicle</th>
				<th class="col-2">No. of vehicles</th>
				<th>Blackout reason</th>
				<th>Status</th>
				<th>Actions</th>
			</tr>
		</thead>
		<tbody>
			{#each data as { blackoutEndDate, blackoutStartDate, blackoutVehicles = [], reason, status, id }}
				<tr>
					<td>
						<p>
							<span>
								{convertDateOnly(blackoutStartDate)}
							</span>
							<br />
							<span>
								{convertTimeOnly(blackoutStartDate)}
							</span>
						</p>
					</td>
					<td>
						<p>
							<span> {convertDateOnly(blackoutEndDate)} </span>
							<br />
							<span> {convertTimeOnly(blackoutEndDate)} </span>
						</p>
					</td>

					<td>
						<p>
							{#if blackoutVehicles !== null}
								{#each blackoutVehicles as { plateNumber, vehicleId }, i}
									<span
										class="link link-text"
										on:keydown={() => {}}
										on:click={() =>
											navigate(
												`/car-management/details/${vehicleId}`
											)}
									>
										{plateNumber}
									</span>
									{#if i + 1 !== blackoutVehicles.length}
										{`, `}
									{/if}
								{/each}
							{/if}
						</p>
					</td>
					<td>
						<p>
							{blackoutVehicles?.length > 0
								? blackoutVehicles?.length
								: "No data"}
						</p>
					</td>
					<td>
						<p>
							<span>{reason} </span>
						</p>
					</td>
					<td>
						{#if status === true}
							<p class="status-bar status-bar-1">Active</p>
						{:else if status === false}
							<p class="status-bar status-bar-3">Inactive</p>
						{/if}
					</td>
					<td>
						<TableDropdown>
							<DropdownItem
								on:click={() => {
									editBlackoutData.set({
										id,
										stats: true,
									});
									navigate(`/blackout-management/edit/${id}`);
								}}>Edit Details</DropdownItem
							>
							{#if status === true}
								<DropdownItem
									on:click={() => handleInactive(id, status)}
									>Set as Inactive</DropdownItem
								>
							{:else if status === false}
								<DropdownItem
									on:click={() => handleInactive(id, status)}
									>Set as Active</DropdownItem
								>
							{/if}
						</TableDropdown>
					</td>
				</tr>
			{/each}
		</tbody>
	</Table>
	{#if data.totalCount == 0}
		<p class="text-center">No data to display</p>
	{/if}
	<Pagination totalRecord={data.totalCount} />
	<CustomModal />
</LoaderContainer>
